import { render, staticRenderFns } from "./FormPresencaOLD.vue?vue&type=template&id=978c95d6"
import script from "./FormPresencaOLD.vue?vue&type=script&lang=js"
export * from "./FormPresencaOLD.vue?vue&type=script&lang=js"
import style0 from "./FormPresencaOLD.vue?vue&type=style&index=0&id=978c95d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports